import React from "react";

const TextWarning = ({ message , className, style, color='red' }) => {
  return message ? <p className={className } style={{ color, ...style }}>{message}</p> : null;
};

export default TextWarning;